var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_12972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0003 11.3327H4.66699V1.99935H14.0003M14.0003 0.666016H4.66699C4.31337 0.666016 3.97423 0.806491 3.72418 1.05654C3.47413 1.30659 3.33366 1.64573 3.33366 1.99935V11.3327C3.33366 11.6863 3.47413 12.0254 3.72418 12.2755C3.97423 12.5255 4.31337 12.666 4.66699 12.666H14.0003C14.3539 12.666 14.6931 12.5255 14.9431 12.2755C15.1932 12.0254 15.3337 11.6863 15.3337 11.3327V1.99935C15.3337 1.64573 15.1932 1.30659 14.9431 1.05654C14.6931 0.806491 14.3539 0.666016 14.0003 0.666016ZM2.00033 3.33268H0.666992V13.9994C0.666992 14.353 0.807468 14.6921 1.05752 14.9422C1.30757 15.1922 1.6467 15.3327 2.00033 15.3327H12.667V13.9994H2.00033M10.6403 6.85935L8.80699 9.21935L7.50033 7.64602L5.66699 9.99935H13.0003L10.6403 6.85935Z",
    fill: "#0091EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_12972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImages);
export default __webpack_public_path__ + "static/media/images.826ebc5a57ea9323148b07b154aa9aaf.svg";
export { ForwardRef as ReactComponent };